// GEEN UmlDiagramItem-subtype: puur een tekstregel binnen UmlClassShape.members[].
// Geen eigen x/y — positie is afgeleid (rij-index binnen de class-box).
class UmlMemberText {
  constructor(id, text, visibility, memberKind, description, paramCount, smells, name, dependencies) {
    this.id = id;
    this.text = text;
    this.visibility = visibility; // '+', '-', '#'
    this.memberKind = memberKind; // 'method' | 'field' | 'constructor'
    this.description = description || null; // vrije tekst, XMLDoc/JSDoc-achtig, optioneel
    this.paramCount = paramCount ?? null; // alleen relevant voor memberKind='method'|'constructor'
    this.smells = smells || []; // string[] code-smell-remarks, zie Core/CsImport/CsMemberSmells.js
    this.name = name || null; // bare member name (zonder params/type), o.a. voor de constructor-tooltip
    this.dependencies = dependencies || []; // {name, type}[] — alleen relevant voor memberKind='constructor'
  }

  setText(text) {
    this.text = text;
  }

  setDescription(description) {
    this.description = description;
  }

  setSmells(smells) {
    this.smells = smells;
  }
}

export default UmlMemberText;
